<p *ngIf="istEinrichtung && !disabled && !bearbeitung">
  <button type="button" class="btn btn-success" [disabled]="aktionLaeuft" (click)="bearbeiten()"><span class="glyphicon glyphicon-plus" aria-hidden="true"></span> Bemerkung hinzufügen</button>
</p>
<p *ngIf="aktionLaeuft" role="status">{{ aktionStatus }}</p>
<div *ngIf="aktionsfehler" class="alert alert-danger" role="alert">
  {{ aktionsfehler }}
  <button *ngIf="loeschkonflikt" type="button" class="btn btn-default" (click)="listeNeuLaden()">Liste neu laden</button>
</div>
<cz-bemerkungen-html-editor *ngIf="bearbeitung" [bemerkung]="bearbeitung"
  (gespeichert)="htmlGespeichert()" (abgebrochen)="bearbeitung = null"></cz-bemerkungen-html-editor>
<dx-data-grid [dataSource]="dataSource" [disabled]="!!bearbeitung || aktionLaeuft" [hoverStateEnabled]="true" [columnAutoWidth]="true" [wordWrapEnabled]="true"
  [allowColumnResizing]="true" [columnResizingMode]="'nextColumn'" [showRowLines]="true" [showBorders]="true"
  [masterDetail]="{ enabled: true, template: 'rowMasterDetailTemplate' }"
  (onEditorPreparing)="onEditorPreparing($event)" (onToolbarPreparing)="onToolbarPreparing($event)"
  (onCellPrepared)="onCellPrepared($event)"
  (onRowExpanded)="geoeffneteBemerkungen.add($event.key.id)"
  (onRowCollapsed)="geoeffneteBemerkungen.delete($event.key.id)"
  (onInitNewRow)="onInitNewRow($event)">

  <dxo-search-panel placeholder="Suche..." [width]="300" [visible]="true"></dxo-search-panel>

  <dxo-paging [pageSize]="5"></dxo-paging>
  <dxo-pager [showPageSizeSelector]="true" [allowedPageSizes]="[5, 10, 20, 50]" [showInfo]="true"
    infoText="Seite {0} von {1} Seiten ({2} Datensätze)" [showNavigationButtons]="true">
  </dxo-pager>

  <dxo-remote-operations [filtering]="true" [sorting]="true" [paging]="true">
  </dxo-remote-operations>

  <dxo-editing mode="form" [allowUpdating]="!disabled && !istEinrichtung" [allowDeleting]="false" [allowAdding]="!disabled && !istEinrichtung" [useIcons]="true">
    <dxo-form [colCount]="1" [labelLocation]="'top'">
      <dxi-item itemType="group">
        <dxi-item dataField="owi104" editorType="dxCheckBox" [label]="{ visible: false }"
          [editorOptions]="{ text: 'OWI 104'}" [visible]="entityArt === 1">
        </dxi-item>
        <dxi-item dataField="betreff">
          <dxi-validation-rule type="required" reevaluate="true"
            message="'Betreff' wird benötigt!"></dxi-validation-rule>
        </dxi-item>
        <dxi-item dataField="text" editorType="dxTextArea"></dxi-item>
      </dxi-item>
    </dxo-form>
  </dxo-editing>

  <dxi-column dataType="date" format="dd.MM.yyyy" dataField="erstellt"></dxi-column>
  <dxi-column dataField="betreff"></dxi-column>
  <dxi-column [visible]="false" dataField="text" editorType="dxTextArea"></dxi-column>
  <dxi-column dataField="benutzerName" caption="Erstellt durch"></dxi-column>
  <dxi-column dataField="owi104" dataType="boolean" caption="OWI 104" width="70px"
    [visible]="entityArt === 1"></dxi-column>
  <dxi-column *ngIf="istEinrichtung" type="buttons" name="bemerkungAktionen" [visible]="!disabled" [width]="110" [fixed]="true" fixedPosition="right">
    <dxi-button icon="edit" hint="Bearbeiten" [onClick]="onHtmlBearbeiten"></dxi-button>
    <dxi-button icon="trash" hint="Löschen" [onClick]="onHtmlLoeschen"></dxi-button>
    <dxi-button icon="print" hint="Drucken" [onClick]="onHtmlDrucken"></dxi-button>
  </dxi-column>
  <dxi-column *ngIf="istEinrichtung" type="buttons" name="bemerkungDruck" [visible]="disabled" [width]="50" [fixed]="true" fixedPosition="right">
    <dxi-button icon="print" hint="Drucken" [onClick]="onHtmlDrucken"></dxi-button>
  </dxi-column>

  <div *dxTemplate="let bemerkung of 'rowMasterDetailTemplate'">
    <cz-bemerkungen-html-ansicht *ngIf="istEinrichtung && geoeffneteBemerkungen.has(bemerkung.data.id)" [bemerkung]="bemerkung.data"></cz-bemerkungen-html-ansicht>
    <ng-container *ngIf="!istEinrichtung">
    <span *ngIf="!bemerkung.data.text || !bemerkung.data.text.length" class="text-danger">Keine Daten</span>
    <div *ngIf="bemerkung.data.text && bemerkung.data.text.length">
      <div class="row">
        <button class="btn btn-success btn-sm pull-right" type="button" (click)="onClickPrint(bemerkung.data)"
          style="margin-left:5px"><span class="glyphicon glyphicon-print"></span> Drucken</button>
      </div>
      <div class="row" style="margin-top:10px">
        <dx-text-area [readOnly]="true" [(value)]="bemerkung.data.text">
        </dx-text-area>
      </div>
    </div>
    </ng-container>
  </div>
</dx-data-grid>
